import { ColorFunctions as Colors } from '@bubble-ui/particle-colors';

var getDefaultStyleSheet = function getDefaultStyleSheet(_ref) {
  var designVersion = _ref.designVersion,
      designContext = _ref.designContext,
      interactiveState = _ref.interactiveState,
      isFullyDisabled = _ref.isFullyDisabled,
      grey = _ref.grey,
      inverse = _ref.inverse,
      isBig = _ref.isBig,
      isSmall = _ref.isSmall;
  var iconSize = isBig ? 30 : 20; // isSmall (default)

  var clickableRadius = isSmall ? 0 : 6;
  var iconClickableSize = isSmall ? iconSize : iconSize + clickableRadius * 2;
  var borderRadius = designContext.get('touchable-icon/corner-radius').pixelValue;
  return {
    containerStyle: {
      backgroundColor: Colors.transparent(designVersion).toString(),
      border: 'none',
      cursor: isFullyDisabled ? 'default' : 'pointer',
      display: 'block',
      padding: 0,
      position: 'relative',
      outline: 0,
      overflow: 'visible',
      height: iconSize,
      width: iconSize
    },
    focusedBorderStyle: {
      position: 'absolute',
      borderColor: interactiveState === 'keyboardFocused' ? inverse ? Colors.__backgroundInverse(designVersion).toString() : grey ? Colors.__borderNeutral(designVersion).toString() : Colors.__borderDefault(designVersion).toString() : Colors.transparent(designVersion).toString(),
      borderRadius: borderRadius,
      borderStyle: 'solid',
      borderWidth: 2,
      height: iconClickableSize,
      width: iconClickableSize
    },
    overlayStyle: {
      height: iconClickableSize,
      width: iconClickableSize,
      margin: 0 - clickableRadius
    },
    iconWrapperStyle: {
      height: iconSize,
      margin: clickableRadius,
      width: iconSize
    },
    iconColorToken: inverse ? 'colors/text/inverse' : grey ? 'colors/text/neutral' : 'colors/text/default'
  };
};

export default getDefaultStyleSheet;
//# sourceMappingURL=getDefaultStylesheet.js.map